<template>
  <div :class="{ dark: $route.meta.header === 'dark', scrolled }">
    <div class="main-header">
      <div class="container">
        <MainHeaderContent :dark="!scrolled && $route.meta.header === 'dark' "/>
      </div>
    </div>
    <div class="main-header-filler"></div>
  </div>
</template>

<script>
  import MainHeaderContent from './MainHeaderContent.vue'

  export default {
    name: 'MainHeader',
    components: {
      MainHeaderContent
    },
    data() {
      return {
        scrolled: false
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        this.scrolled = window.scrollY > 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../pfx.scss';

  .main-header {
    height: $header-bar-height;
  }
  .main-header-filler {
    height: $header-bar-height + 1rem;
  }
  .main-header {
    width: 100%;
    display: inline-block;
    position: fixed; top: 0; left: 0; right: 0;
    z-index: 100;
    background: $color-header-bg;
    color: $color-header-fg;
    box-shadow: $header-shadow;
    transition: background 1s ease, color 1s ease, box-shadow 1s ease;

    .container {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin: 0 auto;
    }
  }
  .dark {
    .main-header {
      background: rgba(0,0,0,0);
      color: white;
      box-shadow: none;
    }
    .main-header-filler {
      display: none;
      height: 0;
    }
  }
  .scrolled {
    .main-header {
      background: $color-header-bg;
      color: $color-header-fg;
      box-shadow: $header-shadow;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/MainHeader.vue